module.exports = __webpack_public_path__ + "static/media/blaze_retail_logo.905a7b7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blaze_retail_logo.svg
// module id = 2430
// module chunks = 0